// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","multiCity":"multiCity-3L1ea","label":"label-kH_Xs","caption":"caption-aA5jW","input":"input-3M8M3"};